
import {  fetchEID , getLoggedInNumber, isMobileApp, isNativeApp, isNewIOSApp } from '@airtel-lego/native-app-bridge';

import { Keyboard } from 'react-native';
import { LOGIN_CONSTANTS } from '../constants/AppConstants';


export const checkEsimCompatiblity = ({ additionalData, onUserAction, getState, args }: any) => {

    const actions: any[] = [];
    let isEsimCompatible = false;
 
 
    if (isNativeApp({}) && isNewIOSApp()) {
       isEsimCompatible = true
    }
 
    //Store generation date in redux through actions
    const esimData = {
       payload: {
          data: {
             isEsimCompatible
          },
          context: 'appData',
       },
       type: 'storeValuesInRedux',
    };
 
    actions.push(esimData);
    onUserAction({ actions });
 
 };
 
 export const validatePortNumberRevamp = ({ args, onUserAction, getState }: any) => {
    const { storeValues } = getState();
    const msisdn = storeValues?.appData?.msisdn;
    const portNumber = storeValues?.appData?.portingNumber;
    const pincode = storeValues?.pincodeContext?.pincodeDetails?.pincode;
    const lob = storeValues?.appData?.lob;
    const flow = storeValues?.appData?.flow;
    const portingWidgetId = storeValues?.portingWidgetId?.id;
 
    const actions: any[] = [];
 
    if (portNumber === msisdn) {
 
       actions?.push({
          payload: {
             eventData: {
                hintText: 'Porting number and alternate number cannot be the same.',
                state: 'error',
             },
             eventName: "portNumberInput",
          },
          type: 'nativeEventEmitter'
       });
 
 
    } else {
       actions?.push({
          "payload": {
             "authTokenGroup": "SKYC_REVERIFICATION",
             "requestType": "POST",
             "apiUrl": "guardian/api/buy/skyc/fetchmnpdetails/v1",
             "queryParams": {},
             "header": {},
             "body": {
                "pincode": "{{storeValues:appData.address.pincode}}",
                "siNumber": "{{storeValues:appData.portingNumber}}",
                "lob": "{{storeValues:appData.lob}}"
             }
          },
          "type": "apiCall"
       });
    }
 
    return onUserAction?.({
       actions,
    });
 };
 
 
 export const checkReduxData = ({ args, onUserAction, getState }: any) => {
    const { storeValues } = getState();
    const msisdn = storeValues?.appData?.msisdn;
    const actions: any[] = [];
 
    if (!msisdn) {
       actions.push({
          type: 'navigation',
          payload: {
             id: 'redirection',
             screenName: '/new-sim',
             params: {},
             type: 'replace',
          },
       });
    }
 
    return onUserAction?.({
       actions,
    });
 };
 
 
 export const checkVerificationReduxData = ({ args, onUserAction, getState }: any) => {
    const { storeValues } = getState();
    const msisdn = storeValues?.appData?.msisdn;
    const actions: any[] = [];
 
    if (!msisdn) {
       actions.push({
          type: 'navigation',
          payload: {
             id: 'redirection',
             screenName: '/verify',
             params: {},
             type: 'replace',
          },
       });
    }
 
    return onUserAction?.({
       actions,
    });
 };

 export const savedLoggedInSiNumberAndPrefillInput = async (onUserAction: any) => {
    const isApp = isMobileApp();
    const actions: any[] = [];
    try{
      if (isApp) {
         const number: any = await getLoggedInNumber();
         Keyboard.dismiss();
         actions.push({
            type: 'storeValuesInRedux',
            payload: {
               context: 'appData',
               data: {
                  loggedInNumber: number,
                  isUserLoggedIn: true,
               },
            },
         });
         actions.push({
            payload: {
               eventData: {
                  'carouselData[0]:formWidgetData:fields[0]:fieldData.value': number,
               },
               eventName: 'altNumberInputWidget',
            },
            type: 'nativeEventEmitter',
         });
      }
    }catch (err: any) {
      console.error(`Error while calling fetch EID: ${err}`);
   }
  
   return onUserAction?.({
      actions: actions,
   });
};
 
 export const handleAadhaarDetail = ({ args, onUserAction, getState }: any) => {
    const { storeValues } = getState();
    const documentId = storeValues?.appData?.kyc?.documentId;
    const actions: any[] = [];
    const documentType = documentId?.length === 12 ? 'A' : 'V';
    const isCheckBoxTick = storeValues?.appData?.isCheckBoxTick;
   
  
    actions.push( {
       "payload": {
          "data": {
             "kyc:documentType": documentType,
             "kyc:documentId": documentId,
          },
          "context": "appData"
       },
       "type": "storeValuesInRedux"
    });
 
    if(isCheckBoxTick){
       actions.push({
          "payload": {
             "eventData": {
                "buttonData.leftCta.disabled": false,
    
             },
             "eventName": 'VerifyAadhaar_Cta',
          },
          "type": 'nativeEventEmitter',
       });
    }else{
       actions.push({
          "payload": {
             "eventData": {
                "buttonData.leftCta.disabled": true,
    
             },
             "eventName": 'VerifyAadhaar_Cta',
          },
          "type": 'nativeEventEmitter',
       });
    }
   
    
    return onUserAction?.({
       actions,
    });
 };
  
 export const handleCheckBox = ({ args, onUserAction, getState }: any) => {
    const { storeValues } = getState();
    const actions: any[] = [];
    const documentId = storeValues?.appData?.kyc?.documentId;
  
    const checkBoxStatus = args?.[0]?.checkBoxStatus;
 
  
    if((documentId?.length == 12 || documentId?.length == 16) && checkBoxStatus){
       actions.push({
          "payload": {
             "eventData": {
                "buttonData.leftCta.disabled": false,
  
             },
             "eventName": 'VerifyAadhaar_Cta',
          },
          "type": 'nativeEventEmitter',
       });
    }else{
       actions.push({
          "payload": {
             "eventData": {
                "buttonData.leftCta.disabled": true,
             },
             "eventName": 'VerifyAadhaar_Cta',
          },
          "type": 'nativeEventEmitter',
       });
    }
  
    actions.push( {
       type: 'storeValuesInRedux',
       payload: {
          context: 'appData',
          data: {
             isCheckBoxTick: checkBoxStatus
        
          },
       },
    });
  
    return onUserAction?.({
       actions,
    });
 };
  
 
 export const handlefetchEID = async (onUserAction: any) => {
    const actions: any[] = [];
 
    try {
       const res: any = await fetchEID();
 
       if (isNewIOSApp()) {
          const obj1 = {
             type: 'nativeEventEmitter',
             payload: {
                eventName: 'EIDInputWidget',
                eventData: {
                   value: res,
                   disabled: true,
                },
                shouldResolveData: true,
             },
          };
 
          const obj2 = {
             type: 'storeValuesInRedux',
             payload: {
                context: 'appData',
                data: {
                   eid: res,
                },
             },
          };
 
          const obj3 = {
             type: 'nativeEventEmitter',
             payload: {
                eventName: 'confirmEIDCta',
                eventData: {
                   'buttonData.rightCta.disabled': false,
 
                },
                shouldResolveData: true,
             },
          };
 
          actions.push(obj1);
          actions.push(obj2);
          actions.push(obj3);
 
       }
    } catch (err: any) {
       console.error(`Error while calling fetch EID: ${err}`);
    }
 
    return onUserAction?.({
       actions: actions,
    });
 };
 
 
 export const checkPlanBackButton = ({ onUserAction, args, getState }: any) => {
    const { storeValues } = getState();
    const isPhysicalSimFlow = storeValues?.appData?.isPhysicalSimFlow;
    const isEsimFlow = storeValues?.appData?.isEsimSimFlow;
    const actions: any[] = [];
 
 
    if (isPhysicalSimFlow && !isEsimFlow) {
       //new / buy sim screen
       actions.push({
          "type": "navigation",
          "payload": {
             "screenName": "/select-connection",
             "type": "push",
             "shouldAddSearchParams": true,
             "params": {}
          }
       })
    } else {
       actions.push({
          "type": "navigation",
          "payload": {
             "screenName": "/choose-sim-type",
             "type": "push",
             "shouldAddSearchParams": true,
             "params": {}
          }
       })
    }
 
    return onUserAction({
       actions: actions,
    });
 };
 
 
 export const handleAddressChange = ({ onUserAction, args, getState }: any) => {
    const { storeValues } = getState();
    const lob=storeValues?.appData?.lob;
     const actions: any[] = [];
         const modalSection = lob?.toLowerCase() == "prepaid" ? "AddressModalSectionPrepaid" : "AddressModalSectionPostpaid"
         actions.push({
                 "payload": {
                         "modalData": {},
                         "modalSection": modalSection
                 },
                 "actionWithDelayed":500,
                 "type": "openModal"
         })
     
    return onUserAction({
       actions: actions,
    });
 };
 
 export const handleSendSMSPressRevamp = ({
    additionalData,
    onUserAction,
    getState,
 }: any) => {
    const { storeValues } = getState();
    const portingNumber = storeValues?.appData?.portingNumber;;
    const message = `PORT ${portingNumber}`;
    const smsUrl = `sms:1900?body=${encodeURIComponent(message)}`;
 
    // window.open(smsUrl, "_self");
 
    const actions: any[] = [];
    actions?.push(
       {
          type: 'navigation',
          payload: { externalUrl: smsUrl },
       },
    )
 
    return onUserAction?.({
       actions,
    });
 };
 
 export const hideKeyBoard = (props: any) => {
    Keyboard.dismiss();
 };

 //skyc-new bouncer send otp for prepaid
export const callBouncerOtp = ({ args, onUserAction, getState }: any) => {
    const { storeValues } = getState();
    const { milestone } = args;
    const msisdn = storeValues?.appData?.msisdn;
    const actions: any[] = [];
 
    let apiPayload={};
    let apiUrlSentOtp = 'guardian/api/skyc/sendOtp/v1';
    let apiUrlValidateOtp = 'guardian/api/skyc/validateOtp/v1';
 
    if(milestone=="init"){
 
       sessionStorage.removeItem(LOGIN_CONSTANTS.groupId)
 
 
     apiPayload = {
       "payload": {
          "authTokenGroup": LOGIN_CONSTANTS.groupId,
          "headers": {},
          "requestType": "POST",
          "apiUrl": "guardian/api/buy/skyc/track-order/v1",
          "queryParams": {
             "acquisitionType": "SKYC"
          },
          "body": {
             "pageName": "newAcq",
             "lob":"{{storeValues:appData.lob}}"
          },
          "loaderProps": {
             "show": true,
             "dismissAfterResponse": true
          }
       },
       "type": "apiCall"
    }
    }
    
 
    actions?.push({
       type: 'otpConsent',
       payload: {
          msisdn,
          groupId: LOGIN_CONSTANTS.groupId,
          otpDigitCount: 6,
          sessionStorageKey: LOGIN_CONSTANTS.groupId,
          modalProps: {
             width: 392,
             showCross: true,
             onClosePress: {
                actions: [
                   
                ],
             },
          },
          otpWidgetProps: {
             theme: "gen4",
             rtnOnChangeCta: true,
             title: 'Verify mobile number',
             subTitle: '6-digit OTP sent to',
             infoTextTop: 'Enter OTP',
             resendTimerCount: 30,
             numberOfInputs: 6,
             startCounter: true,
             loadingTitle: 'verifying your number',
             state: 'none',
             isValidating: false,
             style: {
                marginTop: -20
             },
             onChangeCtaPress: {
                id: 'onMsisdnChange',
                actions: [
                   {
                   type: 'closeModal',
                   },
                   {
                      "actionWithDelayed":700,
                      "payload": {
                        "modalData": {
                          "animationDuration": 220,
                          "showCross": true,
                          "showSubTitle": false,
                          "showHeaderTitle": false,
                          "isScrollView": false,
                          "closeOnPressMask": true,
                          "width": 392,
                          "disableContentPadding": true,
                          "minDistanceToCloseRatio": 0.2,
                          "swipeEnabled": false,
                          "maxWidth": 392,
                          "containerStyle": {
                            "padding": 0,
                            "backgroundColor": "#F5FBFB"
                          }
                        },
                        "modalSection": "AltNumberModalSection"
                      },
                      "type": "openModal"
                    }
                ],
             },
             id: 'artistOtpModal',
             primaryCtaProps: {
                buttonType: 'primary',
                style: {
             marginTop: 0,
             backgroundColor: "#000000",
             borderColor: "#000000",
             borderTopWidth: 1,
             borderTopColor: "#E6E9EF"
             },
                title: 'Confirm',
                size: 'lg',
                onPress: {
                   actions: [],
                },
             },
          secondaryCtaProps: {
             title: "Resend OTP",
             buttonType: 'tertiary',
             counterSuffix: 's',
             style: {
                marginTop: 16,
                marginBottom: 90,
                alignSelf: 'center',
             },
             version: 'fixed-padding',
             onPress: {
                actions: [],
             },
          },
          onInputFilled: {
             actions: [],
          },
          calloutWidgetProps: {
             description: "Your information stays safe with Airtel",
             iconName: "SecuredIcon",
             state: "success",
             isDark: false,
             showCrossDismissBtn: false,
             style: {
                marginTop: 16,
                marginBottom: 8,
                backgroundColor: "#E8F8EF",
                borderColor: "#E8F8EF"
             }
          }, },
          toastProps: {},
          onSendOtpSuccess: {
             actions: [
                {
                   payload: { args: [], utilName: 'storeBouncerSendOTP' },
                   type: 'callUtilFunction',
                }
             ],
          },
          onSendOtpFailure: {
             actions: [],
          },
          onVerifyOtpSuccess: {
             actions: [
                {
                   payload: { args: [], utilName: 'storeBouncerValidateOTP' },
                   type: 'callUtilFunction',
                },
                apiPayload
             ],
          },
          onVerifyOtpFailure: {
             actions: [
               
             ],
          }
       },
    });
   
    return onUserAction({
       actions
    });
 };

 export const checkDwebFlow = ({ additionalData, onUserAction, getState }: any) => {
    const actions: any[] = [];
    let isMobile = /Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
       navigator.userAgent
    );
    const url = 'https://www.airtel.in/kyc/prepaid-sim?utm_layout=prepaid_sim';

    if (!isMobile) {
       // dweb flow

       actions?.push({
          type: 'navigation',
          payload: { externalUrl: url },
       });
    }
    return onUserAction?.({
       actions,
    });
 };
        